import { AppModal } from '@/components/app-modal'
import { ModalEnum } from '@/interfaces'
import { useStores } from '@/stores/RootStoreContext'
import { Flex, message, Form } from 'antd'
import { observer } from 'mobx-react-lite'
import { planData } from './data'
import Header from './header'
import PlanCard from './plan-card'
import { Button } from 'antd'
import { subscribeFreePlan } from '@/services/assistant-plan.js'
import { useState } from 'react'
import StepOne from './stepOne'
import StepTwo from './stepTwo'

const TestExpiredModal = observer(() => {
  const { modalStore } = useStores()
  const [form] = Form.useForm()

  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState(0)

  const MODAL_ID = ModalEnum.TEST_EXPIRED

  const planCards = planData.map((plan) => (
    <PlanCard key={plan.id} plan={plan} />
  ))

  const handleSubscribeFreePlan = (values) => {
    setLoading(true)
    const FREE_PLAN_ID = 6

    subscribeFreePlan(FREE_PLAN_ID, {
      password: values.password
    })
      .then(({ data }) => {
        if (data) {
          setStep(2)
        } else {
          message.error('Error to subscribe to free plan')
        }
      })
      .catch((error) => {
        console.error(error)
        message.error('Error to subscribe to free plan')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <AppModal
      modalId={MODAL_ID}
      width={{ md: '852px' }}
      destroyOnHidden
      footer={null}
      closable={false}
      maskClosable={false}
      styles={{
        content: {
          borderRadius: 10,
          padding: '45px 42px 36px 42px',
        },
        body: {
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {step === 0 && (
        <>
          <Header />

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 16,
              marginTop: 42,
              marginBottom: 30,
            }}
          >
            {planCards}
          </div>

          <Button
            size="large"
            color="primary"
            variant="outlined"
            style={{
              width: 'min-content',
              borderRadius: 6,
            }}
            onClick={() => setStep(1)}
          >
            Continuar com recursos limitados
          </Button>
        </>
      )}

      {step === 1 && (
        <Form form={form} onFinish={handleSubscribeFreePlan} layout="vertical">
          <div style={{ marginBottom: 24 }}>
            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Confirme sua senha para continuar
            </span>
          </div>
          <StepOne />
          <Flex justify="end" gap="small">
            <Button onClick={() => setStep(0)}>Voltar</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Confirmar
            </Button>
          </Flex>
        </Form>
      )}

      {step === 2 && (
        <Flex vertical gap="middle" align="center">
          <StepTwo />
          <Button
            type="primary"
            onClick={() => modalStore.closeModal(MODAL_ID)}
          >
            Continuar
          </Button>
        </Flex>
      )}
    </AppModal>
  )
})

export default TestExpiredModal
